var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mapbox__wrapper",attrs:{"id":_vm.wrapperId}},[_c('div',{ref:"mapbox",staticClass:"mapbox__map",attrs:{"id":_vm.instanceId}}),(_vm.hasError)?_c('div',{staticClass:"mapbox__error"},[_vm._v("\n        "+_vm._s(_vm.$t('errors.map_not_loadable', { i18nFallback: 'Map could not be loaded.' }))+"\n    ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }